// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Ep-z","imageAndVideoCount":"Fp-z","imageAndVideoContainer":"Gp-z","viewAllReviews":"Hp-z"};